export default {
    '600': 'New user? Sign up.',
    '601': 'Registered user? Log in.',
    '611': 'Enter the correct OTP.',
    '000': 'something went wrong', // fallback if error code doesn't matches
}
